{
  "accountSettings.planDeleteDialog.header": "您確定要刪除此計劃嗎？",
  "accountSettings.planDeleteDialog.content": "刪除後，便無法再使用計劃。",
  "accountSettings.header.text": "建立計劃",
  "accountSettings.header.tooltip": "您在帳戶中建立的第一個忠誠計劃是您的預設計劃。未與其他計劃相關聯的新成員會自動新增至預設計劃。",
  "accountSettings.input.planName.label": "計劃名稱",
  "accountSettings.input.planName.tooltip": "輸入唯一品牌計劃名稱，可協助您行銷忠誠計劃。計劃名稱將在錢包中顯示。",
  "accountSettings.input.planIdentifier.label": "計劃識別碼 (計劃 ID)",
  "accountSettings.input.planIdentifier.tooltip": "建立將在內部用於識別計劃的永久 ID。啟動計劃後，便無法變更 ID。ID 必須為英數字元且僅為小寫字元。",
  "accountSettings.input.planType.label": "計劃類型",
  "accountSettings.input.planType.tooltip": "啟動忠誠計劃後，您僅可在以點數為基礎的計劃之間切換。您無法在以點數為基礎和以花費為基礎的計劃之間切換。",
  "accountSettings.btn.AddNewPlan.tooltip": "新增計劃以管理不同類型成員的多個忠誠計劃。",
  "accountSettings.btn.AddNewPlan.disabled.tooltip": "若要建立新忠誠計劃，請聯絡 SAP Emarsys 支援 {text}",
  "accountSettings.notification.content.learnMoreLinkText": "深入瞭解",
  "accountSettings.notification.content": "設定忠誠計劃結構和類型。啟動計劃後，您無法變更計劃識別碼。{learnMoreLink}。",
  "accountSettings.notification.content.firstPlan": "建立忠誠計劃，您可在忠誠帳戶設定中新增計劃。{learnMoreLink}。",
  "cashbackSettings.notification.content": "啟用現金回饋方案以在忠誠計劃中包含現金回饋方案，管理忠誠兌換券中的現金回饋集區。計劃為啟用中後，您可啟用現金回饋。 ",
  "cashbackSettings.cashbackEnabled.cb.tooltip": "啟用現金回饋方案和定義現金回饋設定。",
  "cashbackSettings.cashbackEnabled.cb.label": "現金回饋",
  "cashbackSettings.cashbackName.input.label": "現金回饋名稱",
  "cashbackSettings.cashbackName.input.tooltip": "現金回饋名稱用於顯示忠誠錢包中的總現金回饋。 ",
  "cashbackSettings.cashbackName.input.placeholder": "現金回饋",
  "cashbackSettings.cashbackLimit.rb.label": "年度現金回饋限制",
  "cashbackSettings.cashbackLimit.rb.tooltip": "選擇是否要限制成員可取得的年度現金回饋金額。",
  "cashbackSettings.cashbackLimit.rb.option.limited": "限制年度現金回饋",
  "cashbackSettings.cashbackLimit.rb.option.unlimited": "無限制現金回饋",
  "cashbackSettings.cashbackLimitValue.input.label": "總現金回饋上限",
  "cashbackSettings.resetAt.label": "年度重設日期",
  "cashbackSettings.resetAt.tooltip.unlimited": "即使設定無限制現金回饋，您仍可選擇要重設年度總現金回饋上限和重新開始計算的日期。",
  "cashbackSettings.resetAt.tooltip.limited": "選擇要重設年度總現金回饋上限和重新開始計算的日期。",
  "languageAndCurrency.deleteDialog.header.language": "您確定要刪除此語言嗎？",
  "languageAndCurrency.deleteDialog.content.language": "刪除此語言後，便會刪除語言設定，您的計劃將不支援此語言。",
  "languageAndCurrency.deleteDialog.header.currency": "您確定要刪除此幣別？",
  "languageAndCurrency.deleteDialog.content.currency": "刪除此幣別後，便會刪除幣別設定，您的計劃將不支援此幣別。",
  "languageAndCurrency.deleteDialog.header.market": "您確定要刪除此市場？",
  "languageAndCurrency.deleteDialog.content.market": "刪除此市場後，便會刪除市場設定，您的計劃將不支援此市場。",
  "languageAndCurrency.languageSelect.label": "選擇語言",
  "languageAndCurrency.languageSelect.placeholder": "-- 選擇語言 --",
  "languageAndCurrency.storeUrl.label": "商店 URL",
  "languageAndCurrency.storeUrl.placeholder": "http://storename@domain.com",
  "languageAndCurrency.storeUrl.tooltip": "定義所選語言的商店網站 URL，URL 會在所有必要設定欄位中自動預設。",
  "languageAndCurrency.currencySelect.label": "選擇幣別",
  "languageAndCurrency.currencySelect.placeholder": "-- 選擇幣別 --",
  "languageAndCurrency.marketSelect.label": "選擇市場",
  "languageAndCurrency.marketSelect.placeholder": "-- 選擇市場 --",
  "languageAndCurrency.notification.learnMoreLinkText": "深入瞭解",
  "languageAndCurrency.notification.marketsLinkText": "市場",
  "languageAndCurrency.notification": "定義忠誠計劃支援的語言、幣別和 {marketsLink}。{learnMoreLink}。",
  "languageAndCurrency.primaryLanguage.title": "主要語言",
  "languageAndCurrency.primaryLanguage.tooltip": "主要語言是在忠誠帳戶上顯示的預設語言，並用於沒有相關聯語言的成員。",
  "languageAndCurrency.additionalLanguage.title": "其他語言",
  "languageAndCurrency.additionalLanguage.addButtonText": "新增語言",
  "languageAndCurrency.primaryCurrency.title": "主要幣別",
  "languageAndCurrency.primaryCurrency.tooltip": "主要幣別是在忠誠帳戶上顯示的預設幣別，並用於沒有相關聯幣別的成員。",
  "languageAndCurrency.additionalCurrency.title": "其他幣別",
  "languageAndCurrency.additionalCurrency.addButtonText": "新增幣別",
  "languageAndCurrency.primaryMarket.title": "主要市場",
  "languageAndCurrency.primaryMarket.tooltip": "市場可以是國家、地區或其他種類，只要您可在網站上建立該種類。市場可讓您透過選擇相關市場以鎖定忠誠優惠目標。",
  "languageAndCurrency.additionalMarket.title": "其他市場",
  "languageAndCurrency.additionalMarket.addButtonText": "新增市場",
  "membershipSettings.calculationPeriodTooltip.points": "選擇您要使用的過去資料量以計算使用者層級和點數。這是根據成員加入忠誠方案時開始的定義期間進行計算。",
  "membershipSettings.calculationPeriodTooltip.spend": "期間會定義您要使用的過去資料量以計算自成員加入忠誠方案起的新成員分配和初始消費獎勵餘額。 ",
  "membershipSettings.notification.learnMoreLinkText": "深入瞭解",
  "membershipSettings.notification": "定義聯絡人加入忠誠計劃時發生的情況，是否應取得先前購買的點數和取得點數的期間。這些設定將不會套用至移轉的聯絡人。{learnMoreLink}。",
  "membershipSettings.title": "成員設定",
  "membershipSettings.contactDistributionRb.label": "新成員分配",
  "membershipSettings.contactDistributionRb.tooltip": "選擇成員在加入忠誠計劃時按層級分配的方式。",
  "membershipSettings.contactDistributionRb.options.firstTier.name": "將新成員新增至第一個層級。",
  "membershipSettings.contactDistributionRb.options.firstTier.tooltip": "使用此功能以使所有新忠誠成員在第一個層級開始。",
  "membershipSettings.contactDistributionRb.options.tierByPeriod.name": "根據定義計算期間內的花費歷史記錄，將新成員新增至層級。",
  "membershipSettings.contactDistributionRb.options.tierByPeriod.tooltip": "使用此以根據加入前的花費，激勵使用者加入忠誠計劃。",
  "membershipSettings.pointsDistribution.title": "點數分配",
  "membershipSettings.pointsDistribution.tooltip": "選擇新成員在加入忠誠計劃時分配點數的方式。",
  "membershipSettings.pointsDistribution.statusPoints.title": "新增狀態點數",
  "membershipSettings.pointsDistribution.statusPoints.tooltip": "根據所選計算期間內的花費，為新成員提供新層級的狀態點數。",
  "membershipSettings.pointsDistribution.balancePoints.title": "新增消費點",
  "membershipSettings.pointsDistribution.balancePoints.tooltip": "根據所選計算期間內的消費，為新成員提供新層級的消費點。",
  "membershipSettings.pointsDistribution.creditBalance.title": "新增歷史記錄消費獎勵餘額",
  "membershipSettings.pointsDistribution.creditBalance.tooltip": "根據所選計算期間內的花費歷史記錄，為新成員提供新層級的初始消費獎勵餘額。",
  "membershipSettings.calculationPeriodRb.title": "計算期間",
  "membershipSettings.calculationPeriodRb.options.beginOfYear.name": "使用自目前年度開始的所有資料。",
  "membershipSettings.calculationPeriodRb.options.byPeriod.name": "將資料限制為先前：",
  "planSettings.notification.learnMoreLinkText": "深入瞭解",
  "planSettings.notification": "定義忠誠計劃設定。啟動計劃後，您無法編輯層級和狀態點數計算。{learnMoreLink}。",
  "updateAndLaunch.launchConfirmationDialog.headline": "您確定要啟動新忠誠計劃嗎？",
  "updateAndLaunch.launchConfirmationDialog.content": "啟動新計劃後，新計劃會取代目前計劃。",
  "updateAndLaunch.launchConfirmationDialog.label": "啟動計劃",
  "updateAndLaunch.notification.beforeFirstLaunch.title": "您目前正在建立忠誠計劃 {planName}/{planId}。",
  "updateAndLaunch.notification.beforeFirstLaunch.content": "已儲存忠誠計劃設定。啟動後，計劃便會正式上線。",
  "updateAndLaunch.notification.showCurrentVersion.title": "忠誠計劃 {planName}/{planId} 現在正式上線，無法編輯。",
  "updateAndLaunch.notification.showCurrentVersion.content": "最新啟動： ",
  "updateAndLaunch.notification.editing.title": "您正在編輯忠誠計劃 {planName}/{planId} 下一個版本。",
  "updateAndLaunch.notification.editing.content": "啟動計劃後，忠誠計劃中的變更會正式上線。",
  "updateAndLaunch.selectVersionMode.title": "選擇版本模式",
  "updateAndLaunch.selectVersionMode.options.editNext.name": "編輯下一個版本",
  "updateAndLaunch.selectVersionMode.options.liveVersion.name": "即時版本",
  "updateAndLaunch.launchPlanBtn.label": "啟動計劃",
  "updateAndLaunch.missingSettings.title": "檢查已完成計劃設定。",
  "updateAndLaunch.missingSettings.content": "若要啟動此計劃，請檢查這些設定：{missingSettings}",
  "updateAndLaunch.missingSettings.invalidTier": "層級設定",
  "updateAndLaunch.missingSettings.joinDefaultInvalid": "您必須先設定預設加入行動，才能啟動計劃。",
  "updateAndLaunch.missingSettings.purchaseDefaultInvalid": "您必須先設定預設購買行動，才能啟動計劃。",
  "updateAndLaunch.missingSettings.noSalesData": "銷售資料",
  "updateAndLaunch.missingSettings.learnMore": "深入瞭解",
  "updateAndLaunch.errors.invalidTier": "您必須先在層級設定中完成設定層級，才能啟動計劃。 ",
  "updateAndLaunch.errors.joinDefaultInvalid": "您的預設加入行動未啟用。",
  "updateAndLaunch.errors.purchaseDefaultInvalid": "您的預設購買行動未啟用。",
  "updateAndLaunch.errors.noSalesData": "您必須先完成設定資料，才能啟動此計劃。請聯絡 SAP Emarsys 支援以尋求協助。",
  "updateAndLaunch.planLaunchStatus.label": "您的計劃正在啟動，可能需要幾小時的時間。您可繼續使用計劃即時版本。",
  "updateAndLaunch.title": "更新並啟動",
  "updateAndLaunch.content.beforeFirstLaunch": "啟動計劃後，便會切換至即時版本模式。若要編輯並重新啟動計劃，請切換至編輯版本模式。",
  "updateAndLaunch.content.afterEdit.learnMoreLinkText": "深入瞭解",
  "updateAndLaunch.content.afterEdit": "若要編輯並重新啟動計劃，請切換至編輯版本模式。即使您編輯下一個版本，即時版本仍為啟用中。啟動新計劃時，新版本會取代即時計劃。{learnMoreLinkText}。",
  "updateAndLaunch.warning.smartInsightsLinkText": "智慧洞察",
  "updateAndLaunch.warning.smartInsights": "您必須先完成 {link} 設定，才能啟動計劃。",
  "onboarding.activationAlert": "已成功完成忠誠計劃上線。",
  "onboarding.title": "忠誠上線",
  "planSettingsCalculationSettings.status": "狀態 ",
  "planSettingsCalculationSettings.title": "計算設定",
  "planSettingsCalculationSettings.tiersCalculationType.label": "層級計算期間",
  "planSettingsCalculationSettings.tiersCalculationType.tooltip.points": "選擇您要計算此層級狀態累計狀態點數的頻率。啟動計劃後，若要編輯此設定，請聯絡 SAP Emarsys 支援 {linkToCustomerSupport}。",
  "planSettingsCalculationSettings.tiersCalculationType.tooltip.spend": "選擇您要計算此層級狀態累計花費消費獎勵的頻率。啟動計劃後，若要編輯此設定，請聯絡 SAP Emarsys 支援 {linkToCustomerSupport}",
  "planSettingsCalculationSettings.tiersCalculationYearlyInterval.label": "層級到期",
  "planSettingsCalculationSettings.tiersCalculationYearlyInterval.tooltip": "選擇您要重設層級狀態並重新開始計算的頻率 (年)。若要編輯此設定，請聯絡 SAP Emarsys 支援 {linkToCustomerSupport}。",
  "planSettingsCalculationSettings.tiersCalculationYearlyInterval.prefix": "年",
  "planSettingsCalculationSettings.tiersCalculationStartYear.label": "第一個層級計算",
  "planSettingsCalculationSettings.tiersCalculationMonthlyInterval.label": "層級到期",
  "planSettingsCalculationSettings.tiersCalculationMonthlyInterval.tooltip": "選擇您要重設層級狀態並重新開始計算的頻率 (月)。若要編輯此設定，請聯絡 SAP Emarsys 支援 {linkToCustomerSupport}。",
  "planSettingsCalculationSettings.statusPointsExpirationType.label.points": "狀態點數到期",
  "planSettingsCalculationSettings.statusPointsExpirationType.label.spend": "忠誠消費獎勵到期",
  "planSettingsCalculationSettings.statusPointsExpirationType.tooltip.points": "選擇要狀態點數過期並重設的時間。若要在啟動計劃後編輯此設定，請聯絡 SAP 支援 {linkToCustomerSupport}",
  "planSettingsCalculationSettings.statusPointsExpirationType.tooltip.spend": "選擇要忠誠消費獎勵過期並重設的時間。您無法在首次啟動後編輯此設定。若要編輯，請聯絡 {linkToCustomerSupport}",
  "planSettingsCalculationSettings.statusPointsValidity.duration.label.points": "狀態點數有效性",
  "planSettingsCalculationSettings.statusPointsValidity.duration.label.spend": "忠誠消費獎勵有效性",
  "planSettingsCalculationSettings.statusPointsValidity.duration.tooltip.points": "定義自成員取得點數當天起的狀態點數有效性。",
  "planSettingsCalculationSettings.statusPointsValidity.duration.tooltip.spend": "定義自成員取得消費獎勵當天起的忠誠消費獎勵有效性。",
  "planSettingsCalculationSettings.statusPointsValidity.duration.prefix": "月",
  "planSettingsCalculationSettings.balancePointsExpiration.label": "消費點到期",
  "planSettingsCalculationSettings.balancePointsExpiration.tooltip": "若要限制點數有效性，請選擇要消費點過期並從成員餘額移除的時間。",
  "planSettingsCalculationSettings.pointsAboutToExpire.duration.label": "點數即將過期",
  "planSettingsCalculationSettings.pointsAboutToExpire.duration.tooltip": "選擇消費點過期前多久才新增至消費點即將過期。",
  "planSettingsCalculationSettings.historicalBalancePoints.label": "餘額點數歷史記錄",
  "planSettingsCalculationSettings.historicalBalancePoints.tooltip": "選擇是否要根據成員加入忠誠計劃時的忠誠活動以授予消費點。當您重新啟動計劃時，此動作僅進行一次。 ",
  "planSettingsCalculationSettings.pointsAboutToExpire.duration.postfix": "天",
  "planSettingsGeneral.title": "計劃設定",
  "planSettingsGeneral.name.label": "計劃名稱",
  "planSettingsGeneral.name.tooltip": "輸入唯一品牌計劃名稱，可協助您行銷忠誠計劃。計劃名稱將在錢包中顯示。",
  "planSettingsGeneral.planType.label": "計劃類型",
  "planSettingsGeneral.planType.tooltip": "首次啟動計劃後，您僅可在以點數為基礎的計劃之間切換。您無法在以點數為基礎和以花費為基礎的計劃之間切換。",
  "planSettingsGeneral.pointsName": "點數名稱",
  "planSettingsGeneral.singlePointName": "單一點數名稱",
  "planSettingsGeneral.loyaltyCreditName": "忠誠消費獎勵名稱",
  "planSettingsGeneral.pointsName.tooltip": "點數是忠誠計劃中的幣別。您可按照偏好進行命名和標記 (例如星星、點數、硬幣)，以便成員可在錢包、獎勵和固定福利中看到。您可在忠誠帳戶的點數中管理幣別。 ",
  "planSettingsGeneral.pointsName.spend.tooltip": "忠誠消費獎勵顯示忠誠錢包中成員消費餘額。其中包含成員取得的額外消費獎勵，並根據定義計劃和層級設定進行計算。",
  "planSettingsGeneral.pointsName.spend.placeholder": "消費獎勵",
  "planSettingsGeneral.currencyIdentifierSign.label": "幣別識別碼",
  "planSettingsGeneral.currencyIdentifierSign.tooltip": "定義幣別識別碼及消費餘額 (包含額外消費獎勵) 在成員忠誠錢包中顯示的方式。",
  "planSettingsGeneral.rewardsAllocationDelay.duration.label": "獎勵分配延遲",
  "planSettingsGeneral.rewardsAllocationDelay.duration.tooltip": "選擇購買後多久將獎勵新增至成員帳戶。",
  "planSettingsGeneral.rewardsAllocationDelay.duration.placeholder": "輸入天數",
  "planSettingsGeneral.multiLangPopup.errorNotification": "所有語言的欄位均為必填。",
  "onBoardingActivation.header": "啟用忠誠帳戶",
  "onBoardingActivation.content": "您可編輯忠誠計劃設定，再啟動計劃。",
  "onBoardingActivation.activateBtn.label": "啟用",
  "onBoardingActivation.content.title": "下一步",
  "onBoardingActivation.content.line1": "設定層級",
  "onBoardingActivation.content.line2": "設定行動",
  "onBoardingActivation.content.line3": "建立獎勵區",
  "onBoardingActivation.content.line14": "啟動計劃",
  "onBoardingSelectPlan.title": "選擇忠誠計劃",
  "onBoardingSelectPlan.content": "為成員選擇偏好的忠誠計劃。所有計劃都可增加忠誠客戶、購買和互動。",
  "onBoardingSelectPlan.readmap.title": "藍圖",
  "onBoardingSelectPlan.points": "點數",
  "onBoardingSelectPlan.spend": "花費",
  "onBoardingSelectPlan.subscription": "訂閱",
  "onBoardingSelectPlan.notice": "* 計劃選擇僅進行一次，無法變更。",
  "salesDataSettings.currency.tooltip": "選擇要用於忠誠計算的幣別，幣別會在智慧洞察一般設定中定義。",
  "salesDataSettings.markets.label": "選擇市場",
  "salesDataSettings.markets.tooltip": "選擇與所選幣別相關聯並與忠誠方案相關的市場，顯示的市場會從銷售資料匯入。",
  "salesDataSettings.priceField.label": "購買欄位",
  "salesDataSettings.priceField.tooltip": "系統會根據您選擇的欄位授予購買或活動點數，欄位會在購買欄位下的智慧洞察設定中定義。",
  "salesDataSettings.currency.addNewBtn.label": "新增幣別",
  "accountSettingsValidator.planName.presence": "輸入計劃名稱。",
  "accountSettingsValidator.planId.presence": "輸入計劃識別碼。",
  "accountSettingsValidator.planId.format": "使用小寫字母 a-z 和數字 0-9 輸入計劃識別碼。",
  "accountSettingsValidator.planId.exclusionIgnoreCase": "此計劃識別碼已使用，請輸入唯一計劃識別碼。",
  "accountSettingsValidator.planType.presence": "輸入計劃類型。",
  "accountSettingsValidator.priceField.presence": "輸入購買欄位。",
  "accountSettingsValidator.priceField.currency.presence": "輸入幣別。",
  "accountSettingsValidator.priceField.markets.presence": "輸入市場。",
  "languageAndCurrencyValidator.language.presence": "輸入語言。",
  "languageAndCurrencyValidator.currency.presence": "輸入幣別名稱。",
  "languageAndCurrencyValidator.storeUrl.url": "輸入有效商店網站 URL。",
  "balancePointsExpiration.duration.presence": "輸入餘額點數到期。",
  "balancePointsExpiration.duration.numericality.notInteger": "輸入大於零的數字作為餘額點數到期。",
  "balancePointsExpiration.duration.numericality.notGreaterThan": "輸入大於零的數字作為餘額點數到期。",
  "planSettingsConstraints.planType.presence": "輸入計劃類型。",
  "planSettingsConstraints.planSettings.name.presence": "輸入計劃名稱。",
  "planSettingsConstraints.planSettings.nameMultiLanguage.presence": "所有語言均需要計劃名稱。",
  "planSettingsConstraints.planSettings.pointsName.presence": "輸入 12 個或更少字元的點數名稱。",
  "planSettingsConstraints.planSettings.pointsNameMultiLanguage.presence": "所有語言均需要點數名稱。",
  "planSettingsConstraints.planSettings.pointsName.length": "輸入 12 個或更少字元的點數名稱。",
  "planSettingsConstraints.planSettings.balancePointsExpiration.duration.messageRequired": "輸入餘額點數到期。",
  "planSettingsConstraints.planSettings.balancePointsExpiration.duration.messageHigherThanZero": "輸入大於零的數字作為餘額點數到期。",
  "planSettingsConstraints.planSettings.rewardsAllocationDelay.duration.presence": "輸入獎勵分配延遲。",
  "planSettingsConstraints.planSettings.rewardsAllocationDelay.duration.numericality.notInteger": "輸入等於或大於零的數字作為獎勵分配延遲。",
  "planSettingsConstraints.planSettings.statusPointsExpirationType.presence": "輸入狀態點數到期。",
  "planSettingsConstraints.planSettings.rules.tiersCalculationYearlyInterval.presence": "輸入層級到期。",
  "planSettingsConstraints.planSettings.rules.tiersCalculationYearlyInterval.numericality.notInteger": "輸入大於零的數字作為層級到期。",
  "planSettingsConstraints.planSettings.rules.tiersCalculationYearlyInterval.numericality.notGreaterThan": "輸入大於零的數字作為層級到期。",
  "planSettingsConstraints.planSettings.rules.statusPointsValidity.duration.presence": "輸入狀態點數到期。",
  "planSettingsConstraints.planSettings.rules.statusPointsValidity.duration.numericality.notInteger": "輸入大於零的數字作為狀態點數到期。",
  "planSettingsConstraints.planSettings.rules.statusPointsValidity.duration.numericality.notGreaterThan": "輸入大於零的數字作為狀態點數到期。",
  "planSettingsConstraints.planSettings.rules.historicalBalancePoints.presence": "輸入歷史記錄餘額點數。",
  "planSettingsConstraints.planSettings.rules.pointsAboutToExpire.duration.presence": "輸入點數即將過期。",
  "planSettingsConstraints.planSettings.rules.pointsAboutToExpire.duration.numericality.notInteger": "輸入大於零的數字作為點數即將過期。",
  "planSettingsConstraints.planSettings.rules.pointsAboutToExpire.duration.numericality.notGreaterThan": "輸入大於零的數字作為點數即將過期。",
  "planSettingsConstraints.planSettings.rules.pointsAboutToExpire.duration.numericality.notLessThan": "輸入點數即將過期，值不可高於點數過期 ({duration} {timeUnit})。",
  "planSettingsConstraints.planSettings.spendPlan.pointsName.presence": "輸入 12 個或更少字元的忠誠消費獎勵名稱。",
  "planSettingsConstraints.planSettings.spendPlan.pointsNameMultiLanguage.presence": "所有語言均需要忠誠消費獎勵名稱。",
  "planSettingsConstraints.planSettings.spendPlan.pointsName.length": "輸入 12 個或更少字元的忠誠消費獎勵名稱。",
  "planSettingsConstraints.planSettings.spendPlan.currencyIdentifierSign.presence": "輸入幣別識別碼。",
  "planSettingsConstraints.planSettings.singlePointName.length": "輸入 12 個或更少字元的單一點數名稱。",
  "planSettingsConstraints.planSettings.singlePointName.presence": "輸入 12 個或更少字元的單一點數名稱。",
  "planSettingsConstraints.planSettings.singlePointNameMultiLanguage.presence": "所有語言均需要單一點數名稱。",
  "planSettingsConstraints.planSettings.contactDistributionCalcType.presence": "輸入計算期間。",
  "planSettingsConstraints.planSettings.contactDistributionCalcPeriod.presence": "輸入計算期間",
  "planSettingsConstraints.planSettings.contactDistributionCalcPeriod.numericality.notInteger": "輸入大於零的數字作為計算期間。",
  "planSettingsConstraints.planSettings.contactDistributionCalcPeriod.numericality.notGreaterThan": "輸入大於零的數字作為計算期間。",
  "planSettingsConstraints.planSettings.cashbackName.presence": "輸入 12 個或更少字元的現金回饋名稱。",
  "planSettingsConstraints.planSettings.cashbackName.length": "輸入 12 個或更少字元的現金回饋名稱。",
  "planSettingsConstraints.cashback.maxAmount.presence": "輸入大於零的數字作為累計金額上限。",
  "planSettingsConstraints.cashback.maxAmount.numericality.notGreaterThan": "輸入大於零的數字作為累計金額上限。",
  "planSettingsConstraints.cashback.resetAt.day.presence": "輸入年度重設日期。",
  "priceField.options.price": "如果您使用一個幣別，請使用此選項。",
  "priceField.options.originalPrice": "如果您使用多個幣別，請使用此選項。",
  "walletConfig.sections.CommonSettings": "一般設定",
  "walletConfig.sections.EarnPage": "取得頁面",
  "walletConfig.sections.JoinPage": "加入頁面",
  "walletConfig.sections.MyActivity": "我的活動",
  "walletConfig.sections.RedeemPage": "兌換頁面",
  "walletConfig.sections.VoucherSettings": "兌換券設定",
  "walletConfig.sections.WelcomePage": "歡迎頁面",
  "walletConfig.sections.CancelMemebership": "取消會員",
  "walletConfig.sections.RemoveVoucher": "移除兌換券",
  "walletConfig.sections.RemoveAccess": "移除存取",
  "walletConfig.groups.additionalSettings": "其他設定",
  "walletConfig.commonSettings.groups.colors": "色彩",
  "walletConfig.commonSettings.groups.font": "字型",
  "walletConfig.commonSettings.groups.generalSettings": "一般設定",
  "walletConfig.commonSettings.fontFace.label": "字型",
  "walletConfig.commonSettings.fontFace.uploadButton": "上傳",
  "walletConfig.commonSettings.primaryColor.label": "主要背景色彩",
  "walletConfig.commonSettings.secondaryColor.label": "次要背景色彩",
  "walletConfig.commonSettings.primaryFontColor.label": "字型色彩",
  "walletConfig.commonSettings.showMobile.label": "顯示客戶錢包的行動裝置",
  "walletConfig.commonSettings.joinGuests.label": "顯示非登入使用者的錢包",
  "walletConfig.commonSettings.hasHowItWorks.label": "啟用運作方式",
  "walletConfig.commonSettings.hideCancelMembership.label": "隱藏取消會員",
  "walletConfig.commonSettings.walletHomePage.label": "錢包首頁",
  "walletConfig.commonSettings.walletHomePage.redeem": "兌換",
  "walletConfig.commonSettings.walletHomePage.reward": "獎勵",
  "walletConfig.joinPage.groups.button": "按鈕",
  "walletConfig.joinPage.buttonSingleColor.label": "按鈕單一色彩",
  "walletConfig.joinPage.buttonPosition.comment": "在右側面板中選擇行動裝置和桌上型裝置的按鈕位置。",
  "walletConfig.joinPage.isButtonClosedMobile.label": "行動裝置的按鈕已關閉",
  "walletConfig.joinPage.buttonJoinWidth.label": "按鈕連結寬度 (px)",
  "walletConfig.textFields.placeholder": "在此輸入內文",
  "walletConfig.joinPage.buttonJoinWidthMobile.label": "行動裝置按鈕連結寬度 (px)",
  "walletConfig.welcomePage.groups.logo": "商標",
  "walletConfig.welcomePage.groups.urlLinks": "URL 連結",
  "walletConfig.welcomePage.groups.additionalSettings": "其他設定",
  "walletConfig.welcomePage.logoFileName.label": "標籤放置於此處",
  "walletConfig.welcomePage.linkLogin.label": "連結登入",
  "walletConfig.welcomePage.linkRegister.label": "連結註冊",
  "walletConfig.welcomePage.linkTerms.label": "連結條款",
  "walletConfig.welcomePage.afterJoinLandingPageURL.label": "加入連結後的登陸頁面",
  "walletConfig.earnPage.groups.earnGroupOrder": "取得群組順序",
  "walletConfig.earnPage.showTimeOnActions.label": "顯示行動的時間",
  "walletConfig.redeemPage.groups.rewardGroupsOrder": "兌換群組順序",
  "walletConfig.redeemPage.showTimeOnVouchers.label": "顯示兌換券的時間",
  "walletConfig.myActivity.groups.headerValues": "標題值",
  "walletConfig.myActivity.groups.additionalSettings": "其他設定",
  "walletConfig.myActivity.headerValues.label": "選擇儲存格並重新排列其順序",
  "walletConfig.myActivity.headerValues.comment": "由上往下的儲存格會對應至錢包標題中由左至右的值。",
  "walletConfig.myActivity.hideTiersBar.label": "隱藏層級列",
  "walletConfig.myActivity.headerValue.cashback.label": "現金回饋點數",
  "walletConfig.myActivity.headerValue.empty.label": "空白",
  "walletConfig.myActivity.headerValue.pendingCashback.label": "待處理現金回饋",
  "walletConfig.myActivity.headerValue.expiresSoon.label": "即將過期",
  "walletConfig.myActivity.headerValue.pendingPoints.label": "待處理",
  "walletConfig.myActivity.headerValue.pointsToSpend.label": "消費點",
  "walletConfig.myActivity.headerValue.statusPoints.label": "狀態點數",
  "walletConfig.myActivity.headerValue.position.left": "左",
  "walletConfig.myActivity.headerValue.position.middle": "中",
  "walletConfig.myActivity.headerValue.position.right": "右",
  "walletConfig.voucherSettings.groups.voucher": "兌換券",
  "walletConfig.voucherSettings.hideVoucherCode.label": "隱藏兌換券代碼",
  "walletConfig.voucherSettings.linkCart.label": "連結購物車",
  "walletConfig.multiLangPopupTitle": "以語言為基礎的 URL"
}
